import { render, staticRenderFns } from "./ListGoldBatches.vue?vue&type=template&id=e03678f0&"
import script from "./ListGoldBatches.vue?vue&type=script&lang=js&"
export * from "./ListGoldBatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports